import { render, staticRenderFns } from "./download-wx.vue?vue&type=template&id=3cf2ff29&scoped=true&"
import script from "./download-wx.vue?vue&type=script&lang=ts&"
export * from "./download-wx.vue?vue&type=script&lang=ts&"
import style0 from "./download-wx.vue?vue&type=style&index=0&id=3cf2ff29&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf2ff29",
  null
  
)

export default component.exports